export default __webpack_public_path__ + "static/7i-d58264d95a88a19dca5b1cc58f877c07.woff";